import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import CourseSearch from './CourseSearch';
import CourseTag from './CourseTag';
import CourseCategory from './CourseCategory';

class CourseSidebar extends Component {
    render() {
        return (
            <div className="course-sidebar">
                <Row>
                    <Col md="12">
                        <CourseSearch _searchProject = {this.props._searchProject}/>
                    </Col>
                    <Col md="12">
                        <CourseCategory _category_ID = {this.props._category_ID} _starting = {this.props._starting}/>
                    </Col>
                
                </Row>
            </div>
        )
    }
}

export default CourseSidebar
